export default {
  "reviews.title": "Reviews",
  "reviews.subtitle": "See customer reviews for the laundry and its drivers",
  "reviews.demoNote": "This is a preview with demo data.",

  "reviews.tab.laundry": "Laundry reviews",
  "reviews.tab.drivers": "Driver reviews",

  "reviews.overall.title": "Overall laundry rating",
  "reviews.overall.caption": "This number represents the average of customer ratings.",
  "reviews.overall.outOf": "out of 5",
  "reviews.overall.reviewsCount": "Total reviews",
  "reviews.overall.none": "Not rated yet",

  "reviews.list.title": "Customer reviews",
  "reviews.list.empty": "No reviews for the laundry yet",
  "reviews.list.emptyDesc": "Customer reviews will appear here once available.",

  "reviews.card.noComment": "No comment",
  "reviews.card.showMore": "Show more",
  "reviews.card.showLess": "Show less",
  "reviews.card.order": "Order number",
  "reviews.card.viewOrder": "View order",

  "reviews.drivers.title": "Laundry drivers",
  "reviews.drivers.col.name": "Driver",
  "reviews.drivers.col.rating": "Overall rating",
  "reviews.drivers.col.actions": "Actions",
  "reviews.drivers.view": "View reviews",
  "reviews.drivers.notRated": "Not rated yet",
  "reviews.drivers.count": "Total reviews",
  "reviews.drivers.empty": "The laundry has no sub-drivers",
  "reviews.drivers.emptyDesc": "Driver reviews will appear once their accounts are added.",

  "reviews.detail.title": "{{name}} reviews",
  "reviews.detail.back": "Back to drivers",
  "reviews.detail.summary": "Overall driver rating",
  "reviews.detail.empty": "No reviews for this driver yet",
  "reviews.detail.emptyDesc": "Customer reviews for this driver will appear here once available.",

  "reviews.note": "Reviews are display-only; handling abusive reviews is done by the administration.",

  "reviews.error.laundry": "Could not load laundry reviews",
  "reviews.error.drivers": "Could not load driver reviews",
  "reviews.error.detail": "Could not load driver reviews",
  "reviews.notFound": "Driver not found",
  "reviews.notFoundBack": "Back to reviews"
};